<script setup lang="ts">
import {Translation as I18nT} from 'vue-i18n';

withDefaults(defineProps<{
  /** The other Balm's flag, an image: Windows draws flag emoji as bare letters. */
  flag: string;
  /** The sentence, with a `{link}` slot for the address. */
  keypath: string;
  href: string;
  host: string;
  /** A box that stands out, for a reader whose device looks set to the other region. */
  prominent?: boolean;
}>(), {
  prominent: false,
});
</script>

<template>
  <p class="other-balm-note" :class="{'other-balm-note--prominent': prominent}">
    <img :src="flag" alt="" class="other-balm-note__flag"/>
    <i18n-t :keypath="keypath" tag="span">
      <template #link>
        <a :href="href" class="other-balm-note__link">{{ host }}</a>
      </template>
    </i18n-t>
  </p>
</template>

<style scoped lang="scss">
.other-balm-note {
  @include font-body-sm;
  margin: 0;
  text-align: center;
  color: var(--Neutral-UI-neutral-ui-60);
}

.other-balm-note--prominent {
  padding: var(--Spacing-spacing-3) var(--Spacing-spacing-4);
  border: 1px solid var(--Neutral-UI-neutral-ui-30);
  border-radius: 8px;
  background: var(--Neutral-UI-neutral-ui-10);
  text-align: start;
  color: var(--Neutral-UI-neutral-ui-100);
}

.other-balm-note__flag {
  height: 0.75em;
  vertical-align: -0.05em;
  margin-inline-end: var(--Spacing-spacing-3);
  border-radius: 2px;
  box-shadow: 0 0 0 1px var(--Neutral-UI-neutral-ui-20);
}

.other-balm-note__link {
  @include focus-visible;
  color: inherit;
  text-decoration: underline;
  overflow-wrap: anywhere;
}
</style>
